<template>
    <div v-if="ready" :key="key">
        <h4>Modification d'une personne morale</h4>
        <b-card>
            <div class="row mt-0">
                <b-col sm="2">
                    <label class="mt-1">Siren</label>
                </b-col>
                <b-col sm="10">
                    <b-input
                        v-model="form.registration_number"
                        size="sm"
                        class="mb-1"
                        disabled
                        :formatter="sirenFormatter"
                    />
                </b-col>
                <b-col sm="2">
                    <label class="mt-1">Nom</label>
                </b-col>
                <b-col sm="10">
                    <b-input
                        v-model="form.name"
                        size="sm"
                        class="mb-1"
                        :state="!$v.form.name.$invalid"
                    />
                </b-col>
                <b-col sm="2">
                    <label class="mt-1">Forme</label>
                </b-col>
                <b-col sm="10">
                    <b-form-select
                        v-model="form.legal_form_id"
                        size="sm"
                        :options="legalFormsOptions"
                        :state="!$v.form.legal_form_id.$invalid"
                    />
                </b-col>
                <b-col sm="2">
                    <label class="mt-1">Adresse</label>
                </b-col>
                <b-col sm="10">
                    <b-input
                        v-model="form.formatted_address"
                        size="sm"
                        class="mb-1"
                        :state="!$v.form.formatted_address.$invalid"
                    />
                </b-col>

                <template v-if="showChiefRole">
                    <b-col sm="2">
                        <label class="mt-1">Qualité</label>
                    </b-col>
                    <b-col sm="10">
                        <b-form-select
                            v-model="formChiefRole"
                            :options="chiefRoleSelectOptions"
                            size="sm"
                            :state="!chiefRoleIsInvalid"
                        />
                    </b-col>
                </template>
            </div>
            <div class="mt-3">
                <b-button
                    variant="success"
                    size="sm"
                    :disabled="submitIsDisabled"
                    @click="updateMoralPerson"
                >
                    <i class="fas fa-save fa-fw"></i> Enregistrer
                </b-button>

                <b-button variant="secondary" size="sm" @click="resetStatus">
                    <i class="fas fa-times fa-fw"></i> Annuler
                </b-button>
            </div>
        </b-card>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { required, minValue } from 'vuelidate/lib/validators'
import Formatter from '../../../../common/mixins/Formatter'
import ChiefRoleEditMixin from '../../mixins/ChiefRoleEditMixin.vue'

export default {
    name: 'MoralPersonEdit',

    mixins: [Formatter, ChiefRoleEditMixin],

    data() {
        return {
            form: {
                name: '',
                legal_form_id: 0,
                formatted_address: '',
            },
            moralPerson: {},
            ready: true,
            key: Date.now(),
        }
    },

    validations: {
        form: {
            name: { required },
            legal_form_id: { required, minValue: minValue(1) },
            formatted_address: { required },
        },
    },

    created() {
        this.initForm()
    },

    methods: {
        async initForm() {
            await this.getMoralPerson()
            this.form.name = this.moralPerson.name
            this.form.legal_form_id = this.moralPerson.legal_form_id
            this.form.registration_number = this.moralPerson.registration_number
            this.form.formatted_address = this.moralPerson.formatted_address
            this.initChiefRoleFromRecord()
            this.key = Date.now()
            this.ready = true
        },

        async getMoralPerson() {
            try {
                const response = await axios.get(
                    `/moralPersons/${this.personId}`
                )
                this.moralPerson = response.data.data
            } catch (error) {
                // handle error
                console.log(error)
            }
        },

        async updateMoralPerson() {
            try {
                await axios.put(`/moralPersons/${this.personId}`, this.form)
                if (this.showChiefRole) {
                    await this.updateChiefRole()
                }
                await this.$store.dispatch(
                    'legalVM/getClientData',
                    this.client.id
                )
                this.$store.commit('legalVM/RESET_STATUS')
            } catch (error) {
                // handle error
                console.log(error)
            }
        },

        resetStatus() {
            this.$store.commit('legalVM/RESET_PERSON_ID')
            this.$store.commit('legalVM/RESET_STATUS')
        },
    },

    computed: {
        ...mapState({
            client: (state) => state.legalVM.client,
            personId: (state) => state.legalVM.personId,
            personType: (state) => state.legalVM.personType,
            linkType: (state) => state.legalVM.linkType,
            legalFormsOptions: (state) => state.data.options.legalForms,
        }),

        submitIsDisabled() {
            return this.$v.$invalid || this.chiefRoleIsInvalid
        },
    },
}
</script>

<style scoped></style>
